import styled from "styled-components";
import {
  Button as StyledButton,
  ButtonRight as StyledButtonRight,
  Column as StyledColumn
} from "components/Modal/ModalStyled";
import { ButtonLabel as GenericButtonLabel } from "components/Cards/CardsStyled";

export const Modal = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  z-index: 11;
  border-radius: 3px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.25);
`;

export const Column = styled(StyledColumn)`
  margin: 0;
  padding: 20px 0px 5px;
`;

export const ButtonLabel = styled(GenericButtonLabel)`
  white-space: normal;
`;

export const Button = styled(StyledButton)`
  color: ${({ theme }) => theme.primaryButtonColor || theme.primaryColor};
`;

export const ButtonRight = styled(StyledButtonRight)`
  color: ${({ theme }) => theme.primaryButtonColor || theme.primaryColor};
`;

export const ButtonWithIcon = styled.a`
  color: ${({ theme }) => theme.primaryButtonColor || theme.primaryColor};
  text-decoration: none;
  display: contents;

  div {
    &:first-child {
      margin: 0 15px;
    }

    svg,
    img {
      margin: 0;
    }

    img {
      width: 30px;
    }
  }
`;

export const GreyOutArea = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: black;
  filter: alpha(opacity=30);
  opacity: 0.2;
`;
